import React from "react";
import { buildChapterVerseRows } from "../utils/bibleVerses";
import { renderBodyWithPartialHighlights } from "../utils/partialVerseHighlightRender";

const VERSE_NUM_CLASS =
  "align-super text-[0.55em] font-semibold text-[#e2c275] dark:text-[#e2c275] select-none";

/**
 * Renders chapter plain text as one block per verse; partial highlights via offsets in verse body.
 *
 * @param {object} props
 * @param {string} props.text - Full chapter plain text
 * @param {Record<number, { id: string, start_offset: number, end_offset: number, color: string }[]>} [props.highlightsByVerse]
 * @param {(e: React.MouseEvent | React.TouchEvent) => void} [props.onPassageMouseUp] - parent selection handler (Ask/Study / partial highlight)
 */
export function ChapterVerseReader({
  text,
  highlightsByVerse = {},
  onPassageMouseUp,
}) {
  const rows = buildChapterVerseRows(text);

  return (
    <div
      className="serif text-xl leading-relaxed text-[#1E293B] dark:text-[#e8edf5]"
      onMouseUp={onPassageMouseUp}
      onTouchEnd={onPassageMouseUp}
    >
      {rows.map((row) => {
        const { verseNum, body } = row;
        const highlights = verseNum != null ? highlightsByVerse[verseNum] : null;

        if (verseNum == null) {
          return (
            <p key={`pre-${row.start}-${row.end}`} className="mb-1 whitespace-pre-wrap">
              {body}
            </p>
          );
        }

        return (
          <div key={`v-${verseNum}-${row.start}`} data-verse={verseNum} className="mb-1">
            <span className={VERSE_NUM_CLASS} aria-hidden>
              {verseNum}
            </span>{" "}
            <span
              data-verse-body
              data-verse={verseNum}
              className="whitespace-pre-wrap align-top"
            >
              {renderBodyWithPartialHighlights(body, highlights)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
